import axios from 'axios';

let messageCancelToken;
let convCancelToken;
let CancelToken = axios.CancelToken; //eslint-disable-line

const getConvs = (axiosInstance, { userId, selectedConv }) => {
    const url = `v1/messaging/member/${userId}/conversations${selectedConv ? `?selectedId=${selectedConv}` : ''}`;
    if (convCancelToken) {
        convCancelToken();
    }
    return axiosInstance.get(url, {
        cancelToken: new CancelToken((c) => {
            convCancelToken = c;
        }),
    });
};

const getMessages = (axiosInstance, { userId, convId, before, after }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/messages${before ? `?before=${before}` : ''}${after ? `?after=${after}` : ''}`;
    if (messageCancelToken) {
        messageCancelToken();
    }
    return axiosInstance.get(url, {
        cancelToken: new CancelToken((c) => {
            messageCancelToken = c;
        }),
    });
};

const getParticipants = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/participants`;
    return axiosInstance.get(url);
};

const startConv = (axiosInstance, { userId, conv }) => {
    const url = `v1/messaging/member/${userId}/conversations`;
    console.log('axios', conv);
    return axiosInstance.post(url, conv);
};

const postMessage = (axiosInstance, { userId, convId, message }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/messages`;
    return axiosInstance.post(url, message);
};

const setLastRead = (axiosInstance, { userId, convId, lastRead }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/read`;
    return axiosInstance.put(url, { lastRead });
};

const postReport = (axiosInstance, { userId, convId, values }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/reports`;
    return axiosInstance.post(url, values);
};

const archiveConv = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}/archive`;
    return axiosInstance.post(url);
};

const deleteConv = (axiosInstance, { userId, convId }) => {
    const url = `v1/messaging/member/${userId}/conversations/${convId}`;
    return axiosInstance.delete(url);
};

const blockEntity = (axiosInstance, { userId, blockEntityRequest }) => {
    const url = `v1/messaging/member/${userId}/block`;
    return axiosInstance.post(url, blockEntityRequest);
};

const unblockEntity = (axiosInstance, { userId, unblockEntityRequest }) => {
    const url = `v1/messaging/member/${userId}/unblock`;
    return axiosInstance.post(url, unblockEntityRequest);
};

const getBlockedEntities = (axiosInstance, { userId }) => {
    const url = `v1/messaging/member/${userId}/blocked`;
    return axiosInstance.get(url);
};

export {
    getConvs,
    getMessages,
    getParticipants,
    startConv,
    postMessage,
    setLastRead,
    postReport,
    archiveConv,
    deleteConv,
    blockEntity,
    getBlockedEntities,
    unblockEntity,
};
